import L from 'leaflet';

const iconeAzul = new L.Icon({
    iconUrl: require('../img/iconeAzul.png'),
    iconRetinaUrl: require('../img/iconeAzul.png'),
    iconAnchor: [15, 42],
    iconSize: new L.Point(30, 40),
});
const iconeAzulAtivo = new L.Icon({
    iconUrl: require('../img/iconeAzul.png'),
    iconRetinaUrl: require('../img/iconeAzul.png'),
    iconAnchor: [20, 50],
    iconSize: new L.Point(40, 50),
});
const iconeVermelho = new L.Icon({
    iconUrl: require('../img/iconeVermelho.png'),
    iconRetinaUrl: require('../img/iconeVermelho.png'),
    iconAnchor: [15, 42],
    iconSize: new L.Point(30, 40),
});
const iconeAmarelo = new L.Icon({
    iconUrl: require('../img/iconeAmarelo.png'),
    iconRetinaUrl: require('../img/iconeAmarelo.png'),
    iconAnchor: [15, 42],
    iconSize: new L.Point(30, 40),
});
const iconeNormal = new L.Icon({
    iconUrl: require('../img/iconeNormal.png'),
    iconRetinaUrl: require('../img/iconeNormal.png'),
    iconAnchor: [15, 42],
    iconSize: new L.Point(30, 40),
});
const iconeNormalAtivo = new L.Icon({
    iconUrl: require('../img/iconeNormal.png'),
    iconRetinaUrl: require('../img/iconeNormal.png'),
    iconAnchor: [20, 50],
    iconSize: new L.Point(40, 50),
});
const iconeVermelhoAtivo = new L.Icon({
    iconUrl: require('../img/iconeVermelho.png'),
    iconRetinaUrl: require('../img/iconeVermelho.png'),
    iconAnchor: [20, 50],
    iconSize: new L.Point(40, 50),
});
const iconeAmareloAtivo = new L.Icon({
    iconUrl: require('../img/iconeAmarelo.png'),
    iconRetinaUrl: require('../img/iconeAmarelo.png'),
    iconAnchor: [20, 50],
    iconSize: new L.Point(40, 50),
});
const iconeRamoAtividade = (imagem) => {
    return new L.Icon({
        iconUrl: imagem,
        iconRetinaUrl: imagem,
        iconAnchor: [15, 42],
        iconSize: new L.Point(30, 40),
    });
}
export { iconeNormal, iconeAmarelo, iconeVermelho, iconeNormalAtivo, iconeVermelhoAtivo, iconeAmareloAtivo, iconeAzul, iconeAzulAtivo, iconeRamoAtividade };